import React, { useContext, useEffect, useRef, useState } from 'react'
import { ApiGetCall, ApiGetCallAuthKey, ApiGetCDNData, ApiPostCall } from '../../JS/Connector';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import { formatPackageType, GetAllSchoolsByLocation, getBatchName, getpostalcodes, HideLoder, LogInUserID, scrollToFirstInvalidField, shipStationUrlTrack, ShowLoder, truncate, userTimeZone, validateFieldLengths, ymdToDate, YYYYMMDD } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { UserContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import SignatureCanvas from "react-signature-canvas";
import Popup from '../../Components/Popup';
import CustomReactDatePicker from '../../Components/CustomReactDatePicker';
import { useDispatch, useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';
import { setDefaultShippingMethod } from '../../Store/Slices/authSlice';
import { useDefaultShipMethodCall } from '../../Hooks';

function AdminCreateBatch(props) {
    const { shipping_company_name, organization, adminCallNode } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const { UserData, setUserData } = useContext(UserContext);
    const navigate = useNavigate();
    const reduxDispatch = useDispatch();
    const todayDate = new Date().toISOString().substring(0, 10)
    const [createBatchFormData, setCreateBatchFormData] = useState({
        batchName: '',
        Notes: '',
        fileName: '',
        ExtraDocument: '',
        DeliveryDate: '',
        location: '',
        BuildingId: ''
    })
    const [isChecked, setIsChecked] = useState(false);
    const [Locations, setLocations] = useState([]);

    const [BatchData, setBatchData] = useState({
        createbatchflag: 1,
        Phoneno: '',
        Street1: '',
        Street2: '',
        city: '',
        state: 0,
        postalcode: "",
        labelsize: 0,
        Weight: '',
        boxsize: '',
        width: "",
        height: "",
        depth: "",
        default_shipping_method: 0,
        devicetypevalue: 0
    })
    const [AllState, setallstate] = useState([]);
    const initialDefaultAddress = {
        streetline1: "",
        streetline2: "",
        city: "",
        stateOrProvinceCode: "",
        postalCode: "",
        phone_no: ""
    }
    const [deliveryaddress, setdeliveryaddress] = useState(initialDefaultAddress);
    const [Recipients, setRecipients] = useState({
        Name: '',
        Contact: '',
        SchoolName: ''
    })
    const [schoolDetail, setSchoolDetail] = useState('')
    const [showpackingtypelist, setshowpackingtypelist] = useState("d-none");
    const [showcustominputs, setshowcustominputs] = useState("d-none");
    const [WeightError, setWeightError] = useState("");
    const [shipmentButton, setshipmentButton] = useState(true);
    const [ValidateError, setValidateError] = useState('');
    const [ValidateColor, setValidateColor] = useState('');
    const [buildingData, setbuildingData] = useState([]);
    const [ReturnAddress, setReturnAddress] = useState({
        street_line_1: '',
        street_line_2: '',
        city: '',
        state: '',
        postal_code: '',
        phone_no: ''
    });
    const [ReturnAddressId, setReturnAddressId] = useState(0);
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [netsuiteCustomerIds, setNetsuiteCustomerIds] = useState({
        buildingsMap: [],
        autoSelected: null,
        required: false,
    });
    const [SignatureDataForPackedBy, setSignatureDataForPackedBy] = useState('');
    const [shipmentOptions, setShipmentOptions] = useState([]);
    const [selectedShipOption, setSelectedShipOption] = useState({ rateId: null, serviceCode: null });
    const [initialShipMethod, setInitialShipMethod] = useState(0);
    const [isDefaultSelected, setIsDefaultSelected] = useState(null);
    const [showEditReturnAddress, setShowEditReturnAddress] = useState(false);
    const [isValidateDisabled, setIsValidateDisabled] = useState(false);
    const [shipmentId, setShipmentId] = useState(null);

    const methodToCarrier = { 1: "fedex", 2: "ups", 3: "stamps.com" };
    const carrierToMethod = { fedex: 1, ups: 2, "stamps.com": 3 };

    const sigCanvasForPackedBy = useRef({});
    const defaultDeliveryAddress = useRef({});

    const { DefaultShipMethodCall } = useDefaultShipMethodCall();

    useEffect(() => {
        GetAddress();
        GetAllSchoolsByLocation({ setLocations })
        getReturnLocationsNetsuiteCustomerId();
        setshowpackingtypelist('d-none')
        setshowcustominputs('d-none')
        getpostalcodes(setallstate);
        setCreateBatchFormData(prev => ({ ...prev, batchName: '' }));
    }, [])

    function resetValidationState() {
        setshipmentButton(false);
        setShipmentOptions([]);
        setSelectedShipOption({ rateId: null, serviceCode: null });
        setIsValidateDisabled(false);
    }

    function updateBatchField(field, value) {
        setBatchData(prev => ({ ...prev, [field]: value }));
        resetValidationState();
    }

    function updateBatchFields(patch) {
        setBatchData(prev => ({ ...prev, ...patch }));
        resetValidationState();
    }

    async function GetReturnLocations() {
        var vArray = [];
        {
            props.selectedItems.map((item) => {
                vArray.push(item.uuid)
            })
        }
        var raw = JSON.stringify({
            schoolId: props.schoolId,
            ticketIds: vArray
        });
        await ApiPostCall("/tickets/return-locations", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.response == "success") {

                    const alreadySelected = responseRs?.msg?.find(item => item.is_selected === true);
                    const address = defaultDeliveryAddress.current;

                    if (alreadySelected && alreadySelected?.building?.street_line1 && alreadySelected?.building?.city && alreadySelected?.building?.state && alreadySelected?.building?.postal_code) {
                        setReturnAddressId(alreadySelected?.building_id);
                        setReturnAddress(prev => ({
                            ...prev,
                            street_line_1: alreadySelected?.building?.street_line1 || '',
                            street_line_2: alreadySelected?.building?.street_line2 || '',
                            city: alreadySelected?.building?.city || '',
                            state: alreadySelected?.building?.state || '',
                            postal_code: alreadySelected?.building?.postal_code || '',
                            phone_no: address.phone_no || '',
                        }));
                    } else {
                        setReturnAddressId(0);
                        if (address.streetline1) {
                            setReturnAddress(prev => ({
                                ...prev,
                                street_line_1: address.streetline1 || '',
                                street_line_2: address.streetline2 || '',
                                city: address.city || '',
                                state: address.stateOrProvinceCode || '',
                                postal_code: address.postalCode || '',
                                phone_no: address.phone_no || '',
                            }));
                        }
                    }
                    setbuildingData(responseRs.msg)
                }
            }
        });
    }

    async function getReturnLocationsNetsuiteCustomerId() {
        var vArray = [];
        {
            props.selectedItems.map((item) => {
                vArray.push(item.uuid)
            })
        }
        var raw = JSON.stringify({
            schoolId: props.schoolId,
            ticketIds: vArray
        });
        await ApiPostCall("/tickets/return-locations/netsuite-customer", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.response == "success") {
                    setNetsuiteCustomerIds({
                        ...netsuiteCustomerIds,
                        buildingsMap: responseRs?.buildings,
                        required: responseRs?.is_required == 1 ? true : false,
                    });

                    const selected = responseRs.buildings.find(b => b.is_selected === true);
                    if (selected) {
                        setCreateBatchFormData(prev => ({
                            ...prev,
                            BuildingId: selected.building_id
                        }));
                    }
                }
            }
        });
    }

    async function GetAddress() {
        setLoading(true);
        const batchName = getBatchName(userTimeZone);
        await ApiGetCall(`/schools/address?schoolId=${props.schoolId}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                const responseRs = JSON.parse(result);

                var delieveryaddress = responseRs.admin_address;
                var shippingaddress = responseRs.school_address;

                setSchoolDetail(responseRs?.school_detail?.shipping_type)
                setRecipients({ ...Recipients, SchoolName: shippingaddress?.fedex_company_name || responseRs?.school_detail?.name, Contact: shippingaddress?.phone_num, Name: responseRs?.user_details?.first_name + ' ' + responseRs?.user_details?.last_name })

                const defaultAddress = {
                    streetline1: shippingaddress?.street_line,
                    streetline2: shippingaddress?.street_line2,
                    city: shippingaddress?.city,
                    stateOrProvinceCode: shippingaddress?.state_or_province_code,
                    postalCode: shippingaddress?.postal_code,
                    phone_no: shippingaddress?.phone_num
                }

                defaultDeliveryAddress.current = defaultAddress;
                setdeliveryaddress(prev => ({ ...prev, ...defaultAddress }));

                if (delieveryaddress == null) {
                    setBatchData(prev => ({ ...prev, batchname: batchName, notes: "", createbatchflag: 1, Phoneno: "", Street1: "", Street2: '', city: "", state: 0, postalcode: "", labelsize: 0, Weight: "" }))
                } else {
                    setBatchData(prev => ({ ...prev, batchname: batchName, notes: "", createbatchflag: 1, Phoneno: delieveryaddress.contact_number, Street1: delieveryaddress.street_line1, Street2: delieveryaddress.street_line2, city: delieveryaddress.city, state: delieveryaddress.state_or_province_code, postalcode: delieveryaddress.postal_code }))
                }

                setBatchData((prev) => ({ ...prev, default_shipping_method: responseRs?.default_shipping_method || 0 }));

                setCreateBatchFormData(prev => ({
                    ...prev,
                    batchName: batchName,
                    location: responseRs?.school_detail?.location_id
                }));

                GetReturnLocations();
            }
        });
    }

    async function ChangeDeviceType(devicetypevalue) {
        if (devicetypevalue != 4 && devicetypevalue != 0) {
            var raw = JSON.stringify({
                schoolId: props.schoolId,
                deviceType: devicetypevalue,
                ticketIds: props.selectedItems
            });
            await ApiPostCall("/schools/batches/calculate-weight", raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setshowpackingtypelist("");
                    updateBatchFields({ Weight: responseRs, devicetypevalue: devicetypevalue, depth: "", width: "", height: "", boxsize: "0" });
                    setshowcustominputs("d-none");
                }
            });
        } else {
            setshowpackingtypelist("");
            updateBatchFields({ Weight: "", devicetypevalue: devicetypevalue, depth: "", width: "", height: "", boxsize: "0" });
            setshowcustominputs("d-none");
        }
    }

    function addcustominputs(selectedid) {
        var vVal = selectedid.split('-');
        if (selectedid == "custom") {
            updateBatchFields({ depth: "", width: "", height: "" });
            setshowcustominputs("");
        } else {
            updateBatchFields({ depth: vVal[0], width: vVal[1], height: vVal[2] });
            setshowcustominputs("d-none");
        }
    }

    async function handlePdfFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "pdf", maxSizeMB: 5 });
        if (!isFileValid) {
            setNewAlerts(<AlertsComp show={true} variant="danger" msg={validationMsg} />);
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />)
            }, 2000);
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(",")[1];
            setCreateBatchFormData(prev => (
                {
                    ...prev,
                    fileName: file.name,
                    ExtraDocument: base64String
                })
            );
        };
        reader.readAsDataURL(file);
    }

    function handlecheckboxchange(e) {
        resetValidationState();
        setValidateColor("");
        setValidateError("");
        setShowEditReturnAddress(false);

        if (e.target.checked == true) {
            setIsChecked(true)
            setBatchData(prev => ({ ...prev, createbatchflag: 2 }))
            setshipmentButton(false)
        } else {
            setIsChecked(false)
            setBatchData(prev => ({ ...prev, createbatchflag: 1 }))
            setshipmentButton(true)
        }
    }

    const isCarrierAvailable = (carrier) => shipmentOptions?.some(
        (option) => option?.carrier?.toLowerCase() == carrier
    );

    const validatePhoneNo = (value, errorMsg) => {
        if (value != "") {
            if (value.length < 10 || value.length > 15) {
                setValidateError(errorMsg);
                setValidateColor("redText mt-1");
                return false;
            } else {
                setValidateError("");
                setValidateColor("");
                return true;
            }
        } else {
            setValidateError("Please provide a phone number for shipping.");
            setValidateColor("redText mt-1");
            return false;
        }
    };

    const validateShippingAddress = (key, errorMsg) => {
        if (!key || key === "0" || key === 0) {
            setValidateError(errorMsg);
            setValidateColor("redText mt-1");
            return false;
        } else {
            setValidateError("");
            setValidateColor("");
            return true;
        }
    }

    async function checkAddressAndRate() {
        var StampId = process.env.REACT_APP_ShipStation_Stamp;
        var UpsId = process.env.REACT_APP_ShipStation_Ups;
        var Fedex = process.env.REACT_APP_ShipStation_Fedex;
        var isFormValid = CheckValidation({ formID: 'batchNameRequired' });

        const requiredFields = [
            [ReturnAddress.street_line_1, "Please provide a street line in delivery address."],
            [ReturnAddress.city, "Please provide a City in delivery address."],
            [ReturnAddress.state, "Please provide a State in delivery address."],
            [ReturnAddress.postal_code, "Please provide a Postal Code in delivery address."],
        ];

        if (!showEditReturnAddress) {
            requiredFields.push(
                [BatchData.Street1, "Please provide a street line in return address."],
                [BatchData.city, "Please provide a City in return address."],
                [BatchData.state, "Please provide a State in return address."],
                [BatchData.postalcode, "Please provide a Postal Code in return address."],
            )
        }

        for (const [value, errorMsg] of requiredFields) {
            if (!validateShippingAddress(value, errorMsg)) {
                isFormValid = false;
                return;
            }
        }

        if (!validatePhoneNo(BatchData.Phoneno, "Invalid delivery address Phone No.")) {
            isFormValid = false;
            return;
        }

        if (!validatePhoneNo(ReturnAddress.phone_no, "Invalid return address Phone No.")) {
            isFormValid = false;
            return;
        }

        const lengthValidations = [
            [ReturnAddress.street_line_1, 50, "Delivery address line 1 must be 50 characters or fewer."],
            [ReturnAddress.street_line_2, 50, "Delivery address line 2 must be 50 characters or fewer."],
            [ReturnAddress.city, 35, "Delivery address city must be 35 characters or fewer."],
            [ReturnAddress.postal_code, 10, "Delivery address postal code must be 10 characters or fewer."],
            [BatchData.Street1, 50, "Return address line 1 must be 50 characters or fewer."],
            [BatchData.Street2, 50, "Return address line 2 must be 50 characters or fewer."],
            [BatchData.city, 35, "Return address city must be 35 characters or fewer."],
            [BatchData.postalcode, 10, "Return address postal code must be 10 characters or fewer."],
        ];

        const lengthError = validateFieldLengths(lengthValidations);
        if (lengthError) {
            setValidateColor('redText mt-1');
            setValidateError(lengthError);
            isFormValid = false;
            return;
        }

        var verifyPayload = {
            "rate_options": {
                "carrier_ids": [StampId, UpsId, Fedex],
                // "service_codes": [
                //     "usps_priority_mail",
                //     "ups_ground",
                //     "fedex_ground"
                // ]
                "package_types": [
                    'small_flat_rate_box',
                    'medium_flat_rate_box',
                    'large_flat_rate_box',
                    'ups_express_box_small',
                    'ups_express_box_medium',
                    'ups_express_box',
                    'ups__express_box_large',
                    'ups_10_kg_box',
                    'ups_25_kg_box',
                    // 'fedex_extra_large_box_onerate',
                    // 'fedex_large_box_onerate',
                    // 'fedex_medium_box_onerate',
                    // 'fedex_small_box_onerate',
                    'fedex_10kg_box',
                    'fedex_25kg_box',
                    'fedex_large_box',
                    'fedex_medium_box',
                    'fedex_extra_large_box',
                    'package',
                ]
            },
            "shipment": {
                "ship_to": {
                    "name": truncate(Recipients?.Name),
                    "company_name": truncate(Recipients?.SchoolName),
                    "phone": `${Recipients?.Contact || ReturnAddress?.phone_no}`,
                    "address_line1": ReturnAddress.street_line_1,
                    "address_line2": ReturnAddress.street_line_2,
                    "city_locality": ReturnAddress.city,
                    "state_province": ReturnAddress.state,
                    "postal_code": ReturnAddress.postal_code,
                    "country_code": "US"
                },
                "ship_from": {
                    "name": truncate(UserData.UserName) || "",
                    "company_name": truncate(shipping_company_name) || "",
                    "phone": `${BatchData.Phoneno}` || "",
                    "address_line1": BatchData.Street1,
                    "address_line2": BatchData.Street2,
                    "city_locality": BatchData.city,
                    "state_province": BatchData.state,
                    "postal_code": BatchData.postalcode,
                    "country_code": "US"
                },
                "packages": [
                    {
                        "weight": {
                            "value": parseInt(BatchData.Weight),
                            "unit": "pound"
                        },
                        "dimensions": {
                            "unit": "inch",
                            "length": parseInt(BatchData.depth),
                            "width": parseInt(BatchData.width),
                            "height": parseInt(BatchData.height)
                        }
                    }
                ],
            },
            "display_type": 1,
            "building_id": null,
            "building_warehouse_id": null,
            "confirmation": "none",
            "address_residential_indicator": "no"
        }

        if (!isFormValid) {
            scrollToFirstInvalidField('batchNameRequired');
            return
        };
        setLoading(true);
        setIsValidateDisabled(true);
        const raw = JSON.stringify(verifyPayload);
        await ApiPostCall(`${adminCallNode}/batches/check-address-and-rate`, raw).then((result) => {
            if (result == undefined || result == "") {
                setLoading(false);
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.success) {
                    setValidateColor('');
                    setValidateError('');
                    setShipmentId(responseRs.shipment_id);
                    if (responseRs?.rates?.length > 0) {
                        setShipmentOptions(responseRs?.rates);
                        const lowestRate = responseRs?.rates?.reduce((lowest, current) =>
                            current?.total_amount < lowest?.total_amount ? current : lowest
                        );

                        const targetCarrier = methodToCarrier[BatchData.default_shipping_method];
                        const carrierRates = BatchData.default_shipping_method != 0
                            ? responseRs?.rates?.filter((rate) => rate?.carrier?.toLowerCase() == targetCarrier)
                            : [];

                        if (BatchData.default_shipping_method != 0 && carrierRates?.length > 0) {
                            const lowestCarrierRate = carrierRates.reduce((lowest, current) =>
                                current?.total_amount < lowest?.total_amount ? current : lowest
                            );
                            setInitialShipMethod(BatchData.default_shipping_method);
                            setIsDefaultSelected(BatchData.default_shipping_method);
                            setSelectedShipOption({ rateId: lowestCarrierRate?.rate_id, serviceCode: lowestCarrierRate?.service_code || null });
                            setshipmentButton(true);
                        } else if (lowestRate) {
                            // default carrier not available (or no default set) - fall back to cheapest overall
                            const method = carrierToMethod[lowestRate?.carrier?.toLowerCase()];
                            if (method) {
                                setInitialShipMethod(method);
                            }
                            setIsDefaultSelected(null);
                            setSelectedShipOption({ rateId: lowestRate?.rate_id, serviceCode: lowestRate?.service_code || null });
                            setshipmentButton(true);
                        }
                    } else {
                        setShipmentOptions([]);
                        setIsDefaultSelected(null);
                        setValidateColor('redText mt-1');
                        setValidateError('No shipping options found, double-check entered information and try again.');
                    }
                } else {
                    setShipmentOptions([]);
                    setIsDefaultSelected(null);
                    setValidateColor('redText mt-1');
                    setValidateError(responseRs?.message);
                }
            }
        });
    }

    async function createBatchSubmit(flag) {
        var isFormValid = CheckValidation({ formID: 'batchNameRequired' });

        if (BatchData.Phoneno != "") {
            if (BatchData.Phoneno.length < 10 || BatchData.Phoneno.length > 15) {
                setValidateError("Invalid Phone No.");
                setValidateColor("");
                isFormValid = false;
            } else {
                setValidateError("");
                setValidateColor("");
            }
        }

        if (BatchData.Weight > 55) {
            setWeightError("Max Value");
            isFormValid = false;
        } else {
            setWeightError("");
        }

        if (!isFormValid) {
            scrollToFirstInvalidField('batchNameRequired');
            return
        };
        var signatureBase64 = null;
        signatureBase64 = sigCanvasForPackedBy.current.isEmpty() ? null : sigCanvasForPackedBy.current.getTrimmedCanvas().toDataURL("image/png");
        setLoading(true);

        var shippingrequest = {
            "batchName": createBatchFormData.batchName,
            "notes": createBatchFormData.Notes,
            "schoolId": props.schoolId,
            "ticketIds": props.selectedItems,
            "batchFlag": BatchData.createbatchflag,
            "totalTicketAmount": props.IsModal.subtotal,
            "createdBatchDate": todayDate,
            "file": createBatchFormData.ExtraDocument,
            "shippingMethod": 0,
            "userId": LogInUserID,
            "batchDeliveredSignature": signatureBase64,
            "returnLocation": ReturnAddressId == "0" ? null : ReturnAddressId,
            "selectAllFlag": props.selectAllFlag,
            "deliveryDate": createBatchFormData.DeliveryDate || null,
            "tabFlag": props.tabflag == 1 || props.tabflag == 2 || props.tabflag == 3 ? 1 : 2,
            "locationId": createBatchFormData.location || 0,
            "netSuiteCustomerId": createBatchFormData.BuildingId,
            "rateId": selectedShipOption?.rateId || null,
            "label_layout": BatchData.labelsize == 0 ? "PAPER_4X6" : BatchData.labelsize,
            "service_code": selectedShipOption?.serviceCode || null,
            "shipmentId": ReturnAddress?.state?.toLowerCase() == "pr" ? shipmentId : null,
        }
        var raw = JSON.stringify(shippingrequest);
        await ApiPostCall(`${adminCallNode}/shipstation/create-label`, raw).then((result) => {
            if (isDefaultSelected) {
                DefaultShipMethodCall(props.schoolId, isDefaultSelected);
            }
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    var msg = BatchData.createbatchflag == 1 ? "Batch Created Successfully." : "Batch and Shipping Created Successfully."
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    props.setselectedbatchid(0)
                    props.setSelectAllFlag(0);
                    props.setSelectedItems([]);

                    props.setSelectedIdsOpen([])
                    props.setSelectedIdsAtVendor([])
                    props.setSelectedIdsRepairFinished([])
                    props.setSelectedIdsRepairBilled([])
                    props.setSelectedIdsSentOut([])
                    props.setSelectedIdsClosed([]);

                    props.setSelectedIdsOpen1([])
                    props.setSelectedIdsAtVendor1([])
                    props.setSelectedIdsRepairFinished1([])
                    props.setSelectedIdsRepairBilled1([])
                    props.setSelectedIdsSentOut1([])
                    props.setSelectedIdsClosed1([]);

                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        props.setTicketsTabs({ ...props.TicketsTabs, numberOfTicketCount: 0, openTicketTab: "", repairFinishedTicketTab: 'active', repairBilledTicketTab: '', sentOutForRepair: '', atVendorTicketTab: '', SearchForOpen: '', SearchForRepairFinished: '', SearchForRepairBilled: '', searchForSentOutForRepair: '', SearchForAtVendor: '' });
                        props.setIsModal({ ...props.IsModal, CreateBatchmodal: false, CreateBatchbuttonVisible: false })
                        props.setSelectedIds([])
                        setLoading(false);
                        if (BatchData.createbatchflag == 2) {
                            if (responseRs?.msg?.label?.label_download?.png) {
                                shipStationUrlTrack(responseRs?.msg?.label?.label_download?.png);
                            }
                        }
                        props.GetGridData(null, props.tabflag == 4 ? 4 : 5, props.batchid, null, false)
                    }, 3000);
                } else {
                    const errorMessage = responseRs?.show_tickets_error
                        ? responseRs.msg
                        : responseRs?.msg?.label?.errors?.[0]?.message
                        || responseRs?.msg?.message
                        || responseRs?.msg?.error
                        || 'Please ensure the accuracy of your data for ShipStation delivery.';

                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={errorMessage} />);
                    setLoading(false);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 5000);
                }
            }
        });
    }
    const clearSignatureForPackedBy = () => {
        if (SignatureDataForPackedBy != null) {
            setSignatureDataForPackedBy(null)
        } else {
            sigCanvasForPackedBy.current.clear();
        }
    };

    const selectCarrier = (method, carrier) => {
        setInitialShipMethod(method);
        setIsDefaultSelected(null);

        const carrierRates = shipmentOptions?.filter(
            (option) => option?.carrier?.toLowerCase() == carrier
        );

        if (carrierRates?.length > 0) {
            const lowestCarrierRate = carrierRates.reduce((lowest, current) =>
                current?.total_amount < lowest?.total_amount ? current : lowest
            );
            setSelectedShipOption({ rateId: lowestCarrierRate?.rate_id, serviceCode: lowestCarrierRate?.service_code || null });
            setshipmentButton(true);
        }
    };

    const handleReturnAddressChange = (e) => {
        const selectedBuilding = buildingData.find(
            (item) => item.building_id == e.target.value
        );
        setReturnAddressId(e.target.value);
        const selectedBuildingAddress = selectedBuilding?.building;
        if (selectedBuilding && selectedBuildingAddress?.street_line1) {
            setReturnAddress(prev => ({
                ...prev,
                street_line_1: selectedBuildingAddress.street_line1 || '',
                street_line_2: selectedBuildingAddress.street_line2 || '',
                city: selectedBuildingAddress.city || '',
                state: selectedBuildingAddress.state || '',
                postal_code: selectedBuildingAddress.postal_code || '',
                phone_no: selectedBuildingAddress.phone_no || deliveryaddress.phone_no || ''
            }));
        } else {
            setReturnAddress(prev => ({
                ...prev,
                street_line_1: deliveryaddress.streetline1 || '',
                street_line_2: deliveryaddress.streetline2 || '',
                city: deliveryaddress.city || '',
                state: deliveryaddress.stateOrProvinceCode || '',
                postal_code: deliveryaddress.postalCode || '',
                phone_no: deliveryaddress.phone_no || '',
            }));
        }
        resetValidationState();
    }

    const filteredShipmentOptions = shipmentOptions?.filter(
        (option) => option?.carrier?.toLowerCase() == methodToCarrier[initialShipMethod]
    ) || [];

    const modalbody = (
        <div id="batchNameRequired" className="parent">
            <div className="row align-items-center py-2">
                <div className='col-md-6'>
                    <div className='col-12 row'>
                        <div className='col-lg-4 text-start FormLabel'>Batch Name<label className='redText'>*</label></div>
                        <div className="col-lg-8 ps-0 ">
                            <input type="text" autoComplete='off' name='partName' className="form-control partNamee" required value={createBatchFormData.batchName} onChange={(e) => setCreateBatchFormData(prev => ({ ...prev, batchName: e.target.value }))} />
                            <span className="form-text invalid-feedback" >
                                *required
                            </span>
                        </div>
                    </div>
                    <div className="col-12 row align-items-center py-2">
                        <div className='col-lg-4 text-start FormLabel'>Notes<label className='redText'>*</label></div>
                        <div className="col-lg-8 ps-0 ">
                            <textarea className='form-control notesdata' name='Notes' rows={1} value={createBatchFormData.Notes} required onChange={(e) => setCreateBatchFormData(prev => ({ ...prev, Notes: e.target.value }))}></textarea>
                            <span className="form-text invalid-feedback" >
                                *required
                            </span>
                        </div>
                    </div>
                    <div className="col-12 row py-2">
                        <div className='col-lg-4 text-start py-12'>Upload File</div>
                        <div className="col-lg-8 ps-0 ">
                            <input type="file" label="Pdf" name="myFile" accept=".pdf" id="UploadFileId" onChange={(e) => handlePdfFileUpload(e)} />
                            <label className="ImportInventoryBtn col-md-8" htmlFor="UploadFileId">Choose File</label>
                            <label className="ImportInventoryBtn1 col-md-4 text-center" htmlFor="UploadFileId" style={{ backgroundColor: "var(--primary-color)", color: "white", height: "40px", }}>
                                Browse
                            </label>
                            {createBatchFormData.fileName && <label id="ImportInventoryStudentText" className="ps-0 mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{createBatchFormData.fileName}</label>}

                        </div>
                    </div>
                    <div className="col-12 row align-items-center py-2">
                        <div className='col-lg-4 text-start FormLabel'>Location</div>
                        <div className="col-lg-8 ps-0 ">
                            <select className="gradeselect" defaultValue={createBatchFormData.location}
                                onChange={(e) => {
                                    setCreateBatchFormData(prev => ({ ...prev, location: e.target.value }));
                                }}>
                                <option value="0">Select</option>
                                {Locations?.map((item, key) => (
                                    <option key={key} value={item.id} selected={createBatchFormData.location == item.id}>{item.location_name}</option>
                                ))}
                            </select>

                        </div>
                    </div>

                    <div className="col-12 row align-items-start py-2">
                        <div className='col-lg-4 text-start FormLabel'>Billing Location {netsuiteCustomerIds.required && <label className='redText'>*</label>}</div>
                        <div className="col-lg-8 ps-0 ">
                            <select className="gradeselect" required={netsuiteCustomerIds.required} value={createBatchFormData.BuildingId}
                                onChange={(e) => setCreateBatchFormData(prev => ({ ...prev, BuildingId: e.target.value }))}>
                                <option value="0">Select</option>
                                {netsuiteCustomerIds?.buildingsMap?.map((item, key) => (
                                    <option key={key} value={item?.building_id}>{item?.building_name}</option>
                                ))}
                            </select>
                            <span className="form-text invalid-feedback" >
                                *required
                            </span>
                        </div>
                    </div>

                    {schoolDetail == 1 && (
                        <div className='col-md-12 row align-items-center py-2'>
                            <div className='col-lg-4 text-start FormLabel'>Delivery Date</div>
                            <div className='col-lg-8 ps-0 '>
                                <CustomReactDatePicker
                                    selectedDate={createBatchFormData.DeliveryDate ? ymdToDate(createBatchFormData.DeliveryDate) : null}
                                    onChangeHandler={(date) => setCreateBatchFormData(prev => ({ ...prev, DeliveryDate: date ? YYYYMMDD(date) : "" }))}
                                    placeholderText="MM-DD-YYYY"
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className='col-md-6'>
                    {props.selectedItems?.some(item => item.batchflag != 0) && (
                        <div className='d-flex gap-2 mb-3'>
                            <b>Note: </b>
                            <label>Some selected tickets are already part of an existing batch and will be excluded from this batch.</label>
                        </div>
                    )}

                    <div className="greyBox col-12">
                        <div className='fw-600 font-15 text-center'>Packed By Signature:</div>
                        <div className='mt-2 text-center'>
                            {SignatureDataForPackedBy ? (
                                <img src={SignatureDataForPackedBy} alt="Packed By Signature" />
                            ) : (
                                <SignatureCanvas
                                    ref={sigCanvasForPackedBy}
                                    canvasProps={{ width: 350, height: 100, className: "signatureCanvas" }}
                                />
                            )}
                        </div>
                        <div className="text-end"> <label className="cursor-pointer" onClick={clearSignatureForPackedBy}><u>Clear</u></label></div>
                    </div>
                </div>
            </div>

            <div>
                {schoolDetail == 2 && (
                    <div className='align-items-center pb-4 d-flex px-0'>
                        <input id='ship-devices' className='form-check-input mt-0 me-2 ms-0 cursor-pointer' type="checkbox" checked={isChecked} onChange={(e) => handlecheckboxchange(e)} />
                        <label htmlFor='ship-devices'>Ship Devices</label>
                    </div>
                )}
            </div>

            {BatchData.createbatchflag == 2 && (
                <div className='greyBox'>
                    <div className="row mt-3 ">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Delivery Address</div>
                            </div>
                            <hr className="mt-2" />
                            <div className="col-12">{Recipients?.SchoolName || '-'}</div>
                            <div className='col-12 text-start pb-1 shipdevice-font-style pt-2'>Building</div>
                            <div className='col-12 pt-1'>
                                <select value={ReturnAddressId} onChange={handleReturnAddressChange}>
                                    <option value="0">Default {organization} Address</option>
                                    {buildingData?.map((item, index) => {
                                        return <option key={index} value={item.building_id}>
                                            {item.building_name}
                                        </option>
                                    })}
                                </select>
                            </div>
                            {ReturnAddress?.street_line_1 && (
                                <>
                                    <div className='col-12 pt-2'>{ReturnAddress.street_line_1 || ""}, {ReturnAddress.street_line_2 || ""}</div>
                                    <div className='col-12'>{ReturnAddress.city || ""}, {ReturnAddress.state || ""} {ReturnAddress.postal_code || ""}</div>
                                    <div className='col-12'>
                                        <b>Phone Number:</b> {ReturnAddress.phone_no || ""}
                                    </div>
                                </>
                            )}

                            <div className="d-flex align-items-center justify-content-between pt-4">
                                <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Return Address</div>
                            </div>
                            <hr className="mt-2" />
                            <div className='row'>
                                <div className='col-11 pe-0'>
                                    <label className='w-100'>{shipping_company_name}</label>
                                    <label className='w-100'>{BatchData.Street1 || ""}, {BatchData.Street2 || ""}</label>
                                    <label className='w-100'>{BatchData.city || ""}, {BatchData.state || ""} {BatchData.postalcode || ""}</label>
                                </div>
                                <div className='col-1 ps-0'>
                                    <img title='Edit Return Address' src='/images/EditIconNew.svg' className='cursor-pointer'
                                        onClick={() => setShowEditReturnAddress(!showEditReturnAddress)} />
                                </div>
                            </div>
                            {showEditReturnAddress && (
                                <div className='col-12 row'>
                                    <div className="col-xl-6 col-12 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 1*</div>
                                        <input required type="text" autoComplete='off' maxLength={50} name='Street1' className="form-control"
                                            value={BatchData.Street1} onChange={(e) => updateBatchField("Street1", e.target.value)}
                                        />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-6 col-12 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 2</div>
                                        <input type="text" autoComplete='off' name='Street2' maxLength={50} className="form-control"
                                            value={BatchData.Street2} onChange={(e) => updateBatchField("Street2", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-xl-6 col-12 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>City*</div>
                                        <input required type="text" autoComplete='off' maxLength={35} name='city' className="form-control"
                                            value={BatchData.city} onChange={(e) => updateBatchField("city", e.target.value)}
                                        />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-6 col-12 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>State*</div>
                                        <select required name='state' className="form-control" onChange={(e) => updateBatchField("state", e.target.value)}>
                                            <option value="0">Select</option>
                                            {AllState.map((item, i) => {
                                                return <option key={i} value={item.state_code} selected={BatchData.state == item.state_code}>{item.state_code}</option>
                                            })}
                                        </select>
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-6 col-12 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Postal Code*</div>
                                        <input required type="number" autoComplete='off' name='postalcode' className="form-control"
                                            min={0} value={BatchData.postalcode} onChange={(e) => e.target.value?.length <= 10 && updateBatchField("postalcode", e.target.value)}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Shipping Method</div>
                            </div>
                            <hr className="mt-2" />
                            <div className="">
                                <div className="shipdevice-font-style">What device type are you shipping?</div>
                                <div className="pt-1">
                                    <select required onChange={(e) => ChangeDeviceType(e.target.value)}>
                                        <option value="0">Select</option>
                                        <option value="3">iPad</option>
                                        <option value="1">Chromebook/Laptop</option>
                                        <option value="4">Other</option>
                                    </select>
                                    <span className="form-text invalid-feedback" >
                                        *required
                                    </span>
                                </div>
                            </div>
                            <div className={`${showpackingtypelist}`}>
                                <div>
                                    <div className="shipdevice-font-style pt-3">Weight (1 - 55 lbs)*</div>
                                    <div className="input-group pt-1 has-validation">
                                        <input type="number" autoComplete='off' name='weight' min={1} max={55} className="form-control inputOverRideBorderRight" required
                                            value={BatchData.Weight} onChange={(e) => { updateBatchField("Weight", e.target.value); }}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        <span className="input-group-text inputOverRideBorderLeft">lbs</span>
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <span className="Emailinvalid">
                                        {WeightError}
                                    </span>
                                </div>
                                <div>
                                    <div className="shipdevice-font-style pt-3">Box Size(Length x Width x Height)*</div>
                                    <div className="pt-1">
                                        <select required value={BatchData.boxsize} onChange={(e) => { updateBatchField("boxsize", e.target.value); addcustominputs(e.target.value) }}>
                                            <option value="0">Select</option>
                                            {BatchData.Weight >= 1 && BatchData.Weight <= 4 ?
                                                <>
                                                    <option value="12-8-4">12 x 8 x 4</option>
                                                    <option value="14-5-19">14 x 5 x 19</option>
                                                    <option value="custom">Custom</option>
                                                </>
                                                : BatchData.Weight >= 5 && BatchData.Weight <= 10 ?
                                                    <>
                                                        <option value="12-8-4">12 x 8 x 4</option>
                                                        <option value="13-10-7">13 x 10 x 7</option>
                                                        <option value="14-5-19">14 x 5 x 19</option>
                                                        <option value="custom">Custom</option>
                                                    </>
                                                    : BatchData.Weight >= 11 && BatchData.Weight <= 21 ?
                                                        <>
                                                            <option value="12-8-4">12 x 8 x 4</option>
                                                            <option value="13-10-7">13 x 10 x 7</option>
                                                            <option value="14-14-10">14 x 14 x 10</option>
                                                            <option value="custom">Custom</option>
                                                        </>
                                                        : BatchData.Weight >= 22 && BatchData.Weight <= 36 ?
                                                            <>
                                                                <option value="12-8-4">12 x 8 x 4</option>
                                                                <option value="13-10-7">13 x 10 x 7</option>
                                                                <option value="14-14-10">14 x 14 x 10</option>
                                                                <option value="18-16-8">18 x 16 x 8</option>
                                                                <option value="14-12-14">14 x 12 x 14</option>
                                                                <option value="custom">Custom</option>
                                                            </>
                                                            : <option value="custom">Custom</option>
                                            }
                                        </select>
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                </div>
                                <div className={`${showcustominputs} row parent pt-3`}>
                                    <div className='col-md-4 pe-0'>
                                        <div className='input-group has-validation'>
                                            <input type="number" min={0} autoComplete='off' name='depth' className="form-control inputOverRideBorderRight" required
                                                value={BatchData.depth} onChange={(e) => updateBatchField("depth", e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                        e.preventDefault();
                                                    }
                                                }} />
                                            <span className="input-group-text inputOverRideBorderAll">X</span>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                    <div className='col-md-4 px-0'>
                                        <div className='input-group has-validation'>
                                            <input type="number" min={0} autoComplete='off' name='width' className="form-control inputOverRideBorderAll" required
                                                value={BatchData.width} onChange={(e) => updateBatchField("width", e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                        e.preventDefault();
                                                    }
                                                }} />
                                            <span className="input-group-text inputOverRideBorderAll">X</span>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                    <div className='col-md-4 ps-0'>
                                        <div className='input-group has-validation'>
                                            <input type="number" min={0} autoComplete='off' name='height' className="form-control inputOverRideBorderAll" required
                                                value={BatchData.height} onChange={(e) => updateBatchField("height", e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                        e.preventDefault();
                                                    }
                                                }} />
                                            <span className="input-group-text inputOverRideBorderLeft">in</span>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="shipdevice-font-style pt-3">Label Size *</div>
                                <div className="pt-1">
                                    <select required onChange={(e) => updateBatchField("labelsize", e.target.value)}>
                                        <option value="0">Select</option>
                                        <option value="PAPER_85X11_TOP_HALF_LABEL">8.5 x 11 Top Half</option>
                                        <option value="PAPER_4X6">4 x 6</option>
                                        <option value="PAPER_4X8">4 x 8</option>
                                    </select>
                                    <span className="form-text invalid-feedback" >
                                        *required
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 pt-3 text-center'>
                            <button className={`SaveBtn text-center`} style={{ opacity: isValidateDisabled ? 0.5 : 1, cursor: isValidateDisabled ? "not-allowed" : "pointer" }} disabled={isValidateDisabled}
                                onClick={(e) => checkAddressAndRate()}> Calculate Shipping </button>
                            <div className={`${ValidateColor}`}>{ValidateError}</div>
                        </div>
                        {shipmentOptions?.length > 0 && (
                            <div className="col-12 pt-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Available Carriers</div>
                                </div>
                                <hr className="mt-2" />

                                <div className="row px-3 mt-4">
                                    <div className='col-md-4 ps-0'>
                                        <div
                                            className={`carrier-card ${initialShipMethod == 1 ? 'is-selected' : ''} ${!isCarrierAvailable("fedex") ? 'is-disabled' : ''}`}
                                            onClick={() => isCarrierAvailable("fedex") && selectCarrier(1, "fedex")}
                                            style={{ opacity: isCarrierAvailable("fedex") ? 1 : 0.5, cursor: isCarrierAvailable("fedex") ? 'pointer' : 'not-allowed' }}
                                        >
                                            <div className={`d-flex justify-content-between ${initialShipMethod == 1 ? 'mb-2' : ''}`}>
                                                <div>
                                                    <input className='form-check-input me-2' type="radio" checked={initialShipMethod == 1} disabled={!isCarrierAvailable("fedex")} />
                                                    <label>FedEx</label>
                                                </div>
                                                <img src='/images/FedexIcon.svg' />
                                            </div>
                                            {initialShipMethod == 1 && (
                                                <div className='d-flex gap-2' onClick={(e) => e.stopPropagation()}>
                                                    <input id='fedex-default' type='checkbox' className='form-check-input'
                                                        checked={isDefaultSelected == 1} onChange={(e) => setIsDefaultSelected(e.target.checked ? 1 : null)} />
                                                    <label htmlFor='fedex-default'>Set as Default</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <div
                                            className={`carrier-card ${initialShipMethod == 2 ? 'is-selected' : ''} ${!isCarrierAvailable("ups") ? 'is-disabled' : ''}`}
                                            onClick={() => isCarrierAvailable("ups") && selectCarrier(2, "ups")}
                                            style={{ opacity: isCarrierAvailable("ups") ? 1 : 0.5, cursor: isCarrierAvailable("ups") ? 'pointer' : 'not-allowed' }}
                                        >
                                            <div className={`d-flex justify-content-between ${initialShipMethod == 2 ? 'mb-2' : ''}`}>
                                                <div>
                                                    <input className='form-check-input me-2' type="radio" checked={initialShipMethod == 2} disabled={!isCarrierAvailable("ups")} />
                                                    <label>UPS</label>
                                                </div>
                                                <img src='/images/UPS_Logo.svg' />
                                            </div>
                                            {initialShipMethod == 2 && (
                                                <div className='d-flex gap-2' onClick={(e) => e.stopPropagation()}>
                                                    <input id='ups-default' type='checkbox' className='form-check-input'
                                                        checked={isDefaultSelected == 2} onChange={(e) => setIsDefaultSelected(e.target.checked ? 2 : null)} />
                                                    <label htmlFor='ups-default'>Set as Default</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='col-md-4 pe-0'>
                                        <div
                                            className={`carrier-card ${initialShipMethod == 3 ? 'is-selected' : ''} ${!isCarrierAvailable("stamps.com") ? 'is-disabled' : ''}`}
                                            onClick={() => isCarrierAvailable("stamps.com") && selectCarrier(3, "stamps.com")}
                                            style={{ opacity: isCarrierAvailable("stamps.com") ? 1 : 0.5, cursor: isCarrierAvailable("stamps.com") ? 'pointer' : 'not-allowed' }}
                                        >
                                            <div className={`d-flex justify-content-between ${initialShipMethod == 3 ? 'mb-2' : ''}`}>
                                                <div>
                                                    <input className='form-check-input me-2' type="radio" checked={initialShipMethod == 3} disabled={!isCarrierAvailable("stamps.com")} />
                                                    <label>USPS</label>
                                                </div>
                                                <img src='/images/USPS_Logo.svg' />
                                            </div>
                                            {initialShipMethod == 3 && (
                                                <div className='d-flex gap-2' onClick={(e) => e.stopPropagation()}>
                                                    <input id='usps-default' type='checkbox' className='form-check-input'
                                                        checked={isDefaultSelected == 3} onChange={(e) => setIsDefaultSelected(e.target.checked ? 3 : null)} />
                                                    <label htmlFor='usps-default'>Set as Default</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-12 pt-3'>
                                    <select value={selectedShipOption?.rateId} className='form-select' onChange={(e) => {
                                        const newRateId = e.target.value;
                                        const selectedOption = filteredShipmentOptions.find((option) => option.rate_id == newRateId);
                                        setSelectedShipOption({ rateId: newRateId, serviceCode: selectedOption?.service_code || null });
                                        setshipmentButton(true);

                                        const method = carrierToMethod[selectedOption?.carrier?.toLowerCase()];
                                        if (method) {
                                            setInitialShipMethod(method);
                                        }
                                    }}>
                                        {filteredShipmentOptions.map((option, index) => (
                                            <option value={option.rate_id} key={index}>
                                                {option.type} {option.package_type ? (`(${formatPackageType(option.package_type)})`) : ''} - ${option.total_amount || ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

        </div>
    )
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <Popup isshow={props.isShow} size={"lg"} title={BatchData.createbatchflag == 1 ? "Create Batch" : "Create Batch and Label"}
                closePopup={(e) => {
                    setReturnAddressId(0);
                    props.setIsModal({ ...props.IsModal, CreateBatchmodal: false });
                    setCreateBatchFormData(prev => ({ ...prev, batchName: '' })); setshipmentButton(true);
                    setdeliveryaddress(prev => ({ ...prev, ...initialDefaultAddress }));
                    setShipmentOptions([]);
                    setSelectedShipOption({ rateId: null, serviceCode: null });
                    setShowEditReturnAddress(false);
                }}
                modalBody={modalbody} isScrollable={true}
                handleSave={(e) => { setReturnAddressId(0); createBatchSubmit(2) }} visibleSaveBtn={shipmentButton}
                btnText={BatchData.createbatchflag == 1 ? "Create Batch" : "Create Batch and Label"} />
        </div>
    )
}

export default AdminCreateBatch
